<script>
  // @ts-check
  import { createEventDispatcher } from "svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /** The label for the checkbox
   * @type {string} */
  export let label = undefined;

  /** The error message to display
   * @type {string} */
  export let errorMessage = undefined;

  /** Whether the checkbox is checked or not
   * @type {boolean} */
  export let isChecked = false;

  /** Whether the checkbox is disabled or not
   * @type {boolean} */
  export let disabled = false;

  /** Indicates whether the input field is required or not.
   * @type {boolean} */
  export let required = false;

  /**
   * An optional CSS class to be applied to the component.
   * @type {string}
   */
  export let componentClass = "";

  $: checked = isChecked;

  const dispatch = createEventDispatcher();
  function toggleCheck() {
    checked = !checked;
    if (isInvalid) {
      isInvalid = false;
    }
    dispatch("change", { value: checked, id });
  }

  const inputBeforeClass =
    "before:absolute before:top-[0.125rem] before:left-[0.125rem] not:disabled:hover:before:top-[1px] not:disabled:hover:before:left-[1px] before:h-[1.125rem] before:w-[1.125rem] before:bg-black before:rounded-full before:opacity-[0] before:transition-opacity";

  let labelFocusClass = "";

  /** @type {boolean} */
  export let isInvalid = false;
</script>

<div {id} class={componentClass}>
  <label class="inline-block {!disabled ? 'cursor-pointer' : ''} {labelFocusClass}">
    <div class="flex items-center">
      <input
        id={`checkbox-${id}`}
        type="checkbox"
        aria-invalid={isInvalid}
        class="{!disabled
          ? 'cursor-pointer'
          : ''} relative h-6 w-6 appearance-none bg-transparent {inputBeforeClass} not:disabled:hover:border-[2px] border-thin border-thin border-black outline-none checked:before:opacity-[10]"
        {checked}
        {disabled}
        {required}
        on:focusin={() =>
          (labelFocusClass = "outline-black outline-2 outline-offset-4 outline-dashed")}
        on:focusout={() => (labelFocusClass = "")}
        on:change={toggleCheck}
        on:invalid={(event) => {
          event.preventDefault();
          isInvalid = true;
          dispatch("invalid", { id });
        }}
      />
      <span class="label ml-3">
        {#if $$slots.label}
          <slot name="label" />
        {:else}
          {label}
        {/if}
      </span>
    </div>
  </label>
  {#if isInvalid && errorMessage}
    <div class="label mt-1 text-system-red">{errorMessage}</div>
  {/if}
</div>
